function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * dd-resizable.ts 10.3.1
 * Copyright (c) 2021-2022 Alain Dumesny - see GridStack root license
 */
import { DDResizableHandle } from './dd-resizable-handle';
import { DDBaseImplement } from './dd-base-impl';
import { Utils } from './utils';
import { DDManager } from './dd-manager';
var DDResizable = /*#__PURE__*/function (_DDBaseImplement) {
  // have to be public else complains for HTMLElementExtendOpt ?
  function DDResizable(el) {
    var _this;
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, DDResizable);
    _this = _callSuper(this, DDResizable);
    _this.el = el;
    _this.option = option;
    /** @internal */
    _this.rectScale = {
      x: 1,
      y: 1
    };
    /** @internal */
    _this._ui = function () {
      var containmentEl = _this.el.parentElement;
      var containmentRect = containmentEl.getBoundingClientRect();
      var newRect = {
        width: _this.originalRect.width,
        height: _this.originalRect.height + _this.scrolled,
        left: _this.originalRect.left,
        top: _this.originalRect.top - _this.scrolled
      };
      var rect = _this.temporalRect || newRect;
      return {
        position: {
          left: (rect.left - containmentRect.left) * _this.rectScale.x,
          top: (rect.top - containmentRect.top) * _this.rectScale.y
        },
        size: {
          width: rect.width * _this.rectScale.x,
          height: rect.height * _this.rectScale.y
        }
        /* Gridstack ONLY needs position set above... keep around in case.
        element: [this.el], // The object representing the element to be resized
        helper: [], // TODO: not support yet - The object representing the helper that's being resized
        originalElement: [this.el],// we don't wrap here, so simplify as this.el //The object representing the original element before it is wrapped
        originalPosition: { // The position represented as { left, top } before the resizable is resized
          left: this.originalRect.left - containmentRect.left,
          top: this.originalRect.top - containmentRect.top
        },
        originalSize: { // The size represented as { width, height } before the resizable is resized
          width: this.originalRect.width,
          height: this.originalRect.height
        }
        */
      };
    };
    // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
    _this._mouseOver = _this._mouseOver.bind(_this);
    _this._mouseOut = _this._mouseOut.bind(_this);
    _this.enable();
    _this._setupAutoHide(_this.option.autoHide);
    _this._setupHandlers();
    return _this;
  }
  _inherits(DDResizable, _DDBaseImplement);
  return _createClass(DDResizable, [{
    key: "on",
    value: function on(event, callback) {
      _superPropGet(DDResizable, "on", this, 3)([event, callback]);
    }
  }, {
    key: "off",
    value: function off(event) {
      _superPropGet(DDResizable, "off", this, 3)([event]);
    }
  }, {
    key: "enable",
    value: function enable() {
      _superPropGet(DDResizable, "enable", this, 3)([]);
      this.el.classList.remove('ui-resizable-disabled');
      this._setupAutoHide(this.option.autoHide);
    }
  }, {
    key: "disable",
    value: function disable() {
      _superPropGet(DDResizable, "disable", this, 3)([]);
      this.el.classList.add('ui-resizable-disabled');
      this._setupAutoHide(false);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._removeHandlers();
      this._setupAutoHide(false);
      delete this.el;
      _superPropGet(DDResizable, "destroy", this, 3)([]);
    }
  }, {
    key: "updateOption",
    value: function updateOption(opts) {
      var _this2 = this;
      var updateHandles = opts.handles && opts.handles !== this.option.handles;
      var updateAutoHide = opts.autoHide && opts.autoHide !== this.option.autoHide;
      Object.keys(opts).forEach(function (key) {
        return _this2.option[key] = opts[key];
      });
      if (updateHandles) {
        this._removeHandlers();
        this._setupHandlers();
      }
      if (updateAutoHide) {
        this._setupAutoHide(this.option.autoHide);
      }
      return this;
    }
    /** @internal turns auto hide on/off */
  }, {
    key: "_setupAutoHide",
    value: function _setupAutoHide(auto) {
      if (auto) {
        this.el.classList.add('ui-resizable-autohide');
        // use mouseover and not mouseenter to get better performance and track for nested cases
        this.el.addEventListener('mouseover', this._mouseOver);
        this.el.addEventListener('mouseout', this._mouseOut);
      } else {
        this.el.classList.remove('ui-resizable-autohide');
        this.el.removeEventListener('mouseover', this._mouseOver);
        this.el.removeEventListener('mouseout', this._mouseOut);
        if (DDManager.overResizeElement === this) {
          delete DDManager.overResizeElement;
        }
      }
      return this;
    }
    /** @internal */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "_mouseOver",
    value: function _mouseOver(e) {
      // console.log(`${count++} pre-enter ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
      // already over a child, ignore. Ideally we just call e.stopPropagation() but see https://github.com/gridstack/gridstack.js/issues/2018
      if (DDManager.overResizeElement || DDManager.dragElement) return;
      DDManager.overResizeElement = this;
      // console.log(`${count++} enter ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
      this.el.classList.remove('ui-resizable-autohide');
    }
    /** @internal */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "_mouseOut",
    value: function _mouseOut(e) {
      // console.log(`${count++} pre-leave ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
      if (DDManager.overResizeElement !== this) return;
      delete DDManager.overResizeElement;
      // console.log(`${count++} leave ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
      this.el.classList.add('ui-resizable-autohide');
    }
    /** @internal */
  }, {
    key: "_setupHandlers",
    value: function _setupHandlers() {
      var _this3 = this;
      this.handlers = this.option.handles.split(',').map(function (dir) {
        return dir.trim();
      }).map(function (dir) {
        return new DDResizableHandle(_this3.el, dir, {
          start: function start(event) {
            _this3._resizeStart(event);
          },
          stop: function stop(event) {
            _this3._resizeStop(event);
          },
          move: function move(event) {
            _this3._resizing(event, dir);
          }
        });
      });
      return this;
    }
    /** @internal */
  }, {
    key: "_resizeStart",
    value: function _resizeStart(event) {
      this.sizeToContent = Utils.shouldSizeToContent(this.el.gridstackNode, true); // strick true only and not number
      this.originalRect = this.el.getBoundingClientRect();
      this.scrollEl = Utils.getScrollElement(this.el);
      this.scrollY = this.scrollEl.scrollTop;
      this.scrolled = 0;
      this.startEvent = event;
      this._setupHelper();
      this._applyChange();
      var ev = Utils.initEvent(event, {
        type: 'resizestart',
        target: this.el
      });
      if (this.option.start) {
        this.option.start(ev, this._ui());
      }
      this.el.classList.add('ui-resizable-resizing');
      this.triggerEvent('resizestart', ev);
      return this;
    }
    /** @internal */
  }, {
    key: "_resizing",
    value: function _resizing(event, dir) {
      this.scrolled = this.scrollEl.scrollTop - this.scrollY;
      this.temporalRect = this._getChange(event, dir);
      this._applyChange();
      var ev = Utils.initEvent(event, {
        type: 'resize',
        target: this.el
      });
      if (this.option.resize) {
        this.option.resize(ev, this._ui());
      }
      this.triggerEvent('resize', ev);
      return this;
    }
    /** @internal */
  }, {
    key: "_resizeStop",
    value: function _resizeStop(event) {
      var ev = Utils.initEvent(event, {
        type: 'resizestop',
        target: this.el
      });
      if (this.option.stop) {
        this.option.stop(ev); // Note: ui() not used by gridstack so don't pass
      }
      this.el.classList.remove('ui-resizable-resizing');
      this.triggerEvent('resizestop', ev);
      this._cleanHelper();
      delete this.startEvent;
      delete this.originalRect;
      delete this.temporalRect;
      delete this.scrollY;
      delete this.scrolled;
      return this;
    }
    /** @internal */
  }, {
    key: "_setupHelper",
    value: function _setupHelper() {
      var _this4 = this;
      this.elOriginStyleVal = DDResizable._originStyleProp.map(function (prop) {
        return _this4.el.style[prop];
      });
      this.parentOriginStylePosition = this.el.parentElement.style.position;
      var parent = this.el.parentElement;
      var dragTransform = Utils.getValuesFromTransformedElement(parent);
      this.rectScale = {
        x: dragTransform.xScale,
        y: dragTransform.yScale
      };
      if (getComputedStyle(this.el.parentElement).position.match(/static/)) {
        this.el.parentElement.style.position = 'relative';
      }
      this.el.style.position = 'absolute';
      this.el.style.opacity = '0.8';
      return this;
    }
    /** @internal */
  }, {
    key: "_cleanHelper",
    value: function _cleanHelper() {
      var _this5 = this;
      DDResizable._originStyleProp.forEach(function (prop, i) {
        _this5.el.style[prop] = _this5.elOriginStyleVal[i] || null;
      });
      this.el.parentElement.style.position = this.parentOriginStylePosition || null;
      return this;
    }
    /** @internal */
  }, {
    key: "_getChange",
    value: function _getChange(event, dir) {
      var oEvent = this.startEvent;
      var newRect = {
        width: this.originalRect.width,
        height: this.originalRect.height + this.scrolled,
        left: this.originalRect.left,
        top: this.originalRect.top - this.scrolled
      };
      var offsetX = event.clientX - oEvent.clientX;
      var offsetY = this.sizeToContent ? 0 : event.clientY - oEvent.clientY; // prevent vert resize
      var moveLeft;
      var moveUp;
      if (dir.indexOf('e') > -1) {
        newRect.width += offsetX;
      } else if (dir.indexOf('w') > -1) {
        newRect.width -= offsetX;
        newRect.left += offsetX;
        moveLeft = true;
      }
      if (dir.indexOf('s') > -1) {
        newRect.height += offsetY;
      } else if (dir.indexOf('n') > -1) {
        newRect.height -= offsetY;
        newRect.top += offsetY;
        moveUp = true;
      }
      var constrain = this._constrainSize(newRect.width, newRect.height, moveLeft, moveUp);
      if (Math.round(newRect.width) !== Math.round(constrain.width)) {
        // round to ignore slight round-off errors
        if (dir.indexOf('w') > -1) {
          newRect.left += newRect.width - constrain.width;
        }
        newRect.width = constrain.width;
      }
      if (Math.round(newRect.height) !== Math.round(constrain.height)) {
        if (dir.indexOf('n') > -1) {
          newRect.top += newRect.height - constrain.height;
        }
        newRect.height = constrain.height;
      }
      return newRect;
    }
    /** @internal constrain the size to the set min/max values */
  }, {
    key: "_constrainSize",
    value: function _constrainSize(oWidth, oHeight, moveLeft, moveUp) {
      var o = this.option;
      var maxWidth = (moveLeft ? o.maxWidthMoveLeft : o.maxWidth) || Number.MAX_SAFE_INTEGER;
      var minWidth = o.minWidth / this.rectScale.x || oWidth;
      var maxHeight = (moveUp ? o.maxHeightMoveUp : o.maxHeight) || Number.MAX_SAFE_INTEGER;
      var minHeight = o.minHeight / this.rectScale.y || oHeight;
      var width = Math.min(maxWidth, Math.max(minWidth, oWidth));
      var height = Math.min(maxHeight, Math.max(minHeight, oHeight));
      return {
        width: width,
        height: height
      };
    }
    /** @internal */
  }, {
    key: "_applyChange",
    value: function _applyChange() {
      var _this6 = this;
      var containmentRect = {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      };
      if (this.el.style.position === 'absolute') {
        var containmentEl = this.el.parentElement;
        var _containmentEl$getBou = containmentEl.getBoundingClientRect(),
          left = _containmentEl$getBou.left,
          top = _containmentEl$getBou.top;
        containmentRect = {
          left: left,
          top: top,
          width: 0,
          height: 0
        };
      }
      if (!this.temporalRect) return this;
      Object.keys(this.temporalRect).forEach(function (key) {
        var value = _this6.temporalRect[key];
        var scaleReciprocal = key === 'width' || key === 'left' ? _this6.rectScale.x : key === 'height' || key === 'top' ? _this6.rectScale.y : 1;
        _this6.el.style[key] = (value - containmentRect[key]) * scaleReciprocal + 'px';
      });
      return this;
    }
    /** @internal */
  }, {
    key: "_removeHandlers",
    value: function _removeHandlers() {
      this.handlers.forEach(function (handle) {
        return handle.destroy();
      });
      delete this.handlers;
      return this;
    }
  }]);
}(DDBaseImplement);
/** @internal */
DDResizable._originStyleProp = ['width', 'height', 'position', 'left', 'top', 'opacity', 'zIndex'];
export { DDResizable };